<template>
    <div :id="operatorData.operator_status.site_code + '_' + operatorData.operator.operator_code" style="width: 225px;">
        <!-- 休息状态 -->
        <div class="flex flex-row justify-end h-6">
            <div v-if="operatorData.operator_status.is_break" 
                class="px-4 pt-1 bg-teal-500 text-white text-sm rounded-t">
                休憩中&nbsp;&nbsp;<span v-text="breakDuration"></span>
            </div>
        </div>

        <!-- 占位 -->
        <div v-if="!operatorData.operator_status.is_break" class="h-2"></div>

        <!-- 信息卡 -->
        <el-card
            :style="{
                    border: operatorData.operator_status.is_break ? '10px solid #14b8a6' : '1px solid #d1d5db',
                }"
            style="border-radius: 0px; box-shadow: 0 0 #0000; position: relative;">

            <!-- 结束作业按钮 -->
            <div v-if="operatorData.operator_status.is_work" class="absolute top-0 right-0 z-10">
                <el-button type="danger" link @click="handleCloseButton">
                    <el-icon>
                        <Close />
                    </el-icon>
                </el-button>
            </div>

            <!-- 基本信息 -->
            <div class="flex flex-col items-center">
                <!-- 用户名 -->
                <div class="flex flex-row justify-center items-center w-full">
                    <div ref="containerRef" class="text-lg mr-2 overflow-hidden whitespace-nowrap">
                        <div ref="textRef" :class="{ marquee: isOverflowing }">
                            {{ operatorData.operator.organization_name }}
                            {{ operatorData.operator.operator_name }}
                        </div>
                    </div>
                    
                    <el-button v-if="operatorData.operator.schema_primary_key === 'telephone'" link @click="handleUpdateName">
                        <el-icon :size="16">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                                width="100%" height="100%" style="display: block; margin: auto;">
                                <g>
                                    <image x="0" y="-1"
                                        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy1JREFUWEe1ls9rE0EUx9/bGEREqVYRRBARtFZBRAQRrYhKuvMmoSKmBXv33oPX1qMH/wGvKkKrWNLZpEH8gYgI0gZBaxVUBBHEqkURkSY79oXZsI35MUnWOYXs7Hw++327bwYh4iGEOIuIg57npW2WRptJtnOklGe01rcAwAGACRuJyASIKAUAtwFgVUi4qUQkAkIIiYj85KsB4CWngIijRqShRMcCUkphYl/DcN/307lcbk4IMWYj0ZEAESVM7GvD8KAENhJtCwghTpvY19eC20q0JSClPGli77KBa60v1StHywJEdAIRJ7TW3bbwbDY7Vq8cLQkIIfpM7JtbgTcqh7WAlPKoiX1LO/B6ElYCRHSEOxsAbO0E7rpur+M448tr7QUAX2udbirguu5hx3EYvi1CeBER00qpOw0FksnkId/3Gb49QvgfAEh7npfhstQVIKKDJvYdEcJ/c+zZbFYF70RNAdd1D5jYd0YI/2Viz4Z3138EpJT7tdb8ouyKEP7DxJ6v3tpXCBDRPhN7T4TwRRP73VrniopAKpVaVyqVngJAb1RwRPwKAINKqXv1DjUVgWQyedz3/YfBRO7f3ELDNwbttNY1nlf1nX9huOd5DxqdqCoCQogRRLyyfNMrAODDxHgY1CL8s4n9UbPjXEWAiK4DwPnlbnfV87wLRHQukCh/r4ijlk/+iQ+lSqnHzeAr+gAR8ZP3IOKwUuoGXwwk+Lcl/KOJ/YkNvCLQ39+/OxaLzfMfxWKxO5/PfwsWCCdR/U5U1fyD7/tDuVyOX2TrUS4BEQ0BwE0AWPA8j7faFaOWRBX8veM4g1NTU8+syWZiWUAIcRkRL5r/uE9z/68rwY0qtKu9NbHPtAqvlICIuEmcCi3QUIL7hNlS35jYC+3AywIDAwNdS0tL7wBgQ9UiZYlEIrExHo+7Wus+ADgGAHvMvHlEHFJKPW8XXhbgMx4A3K+zyAIAbKpxbc7E/qITeFlASjmiteYG1GjwFzKjtZ6NxWIziDibyWR+dgoPErgGAMOhxb4HMEQslEqlwvT09OsoYLXW4BJwjAWGaa0L8Xi8MDk5ufi/gNXr/gWVaFb7krx7kgAAAABJRU5ErkJggg=="
                                        preserveAspectRatio="none" width="100%" height="100%" />
                                </g>
                            </svg>
                        </el-icon>
                    </el-button>
                </div>

                 <!-- 手机号 -->
                <div class="flex flex-row items-center">
                    <el-icon class="mr-2" :size="18">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                            width="100%" height="100%" style="display: block; margin: auto;">
                            <g>
                                <image x="0" y="0"
                                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAdRJREFUaEPtWjFOw0AQ3PVLQIIGWugDXc5OSw0NFDyC8AgKaKCmje/SAT200BCJvMQLZ9nIQoLM2joE0qZMZud25m5iybdMPT7OuYKZJ0S0T0QbPSi6JQsiuhORWQih1HKxtsA5N2XmM20dgheR8xDCFMG2GJUA59wOMz9qFtBiRWQ3hPCE1qkE5Hl+TUSHKHlP3I33/git1Qp4I6I1lLwnbum9X0drtQIEJR6C897DfcHA2FCe558CmHlvSJNfa0Xkvv3uVwRoFkGEds3RcPfeAc0iJuAHB2wHkOOBYCwDKV1KyW0ZQNxFMJaBlC6l5LYMIO4iGMtASpdSclsGEHcRjGUgpUspuS0DiLsIxjKQ0qWU3JYBxF0EYxlI6VJKbssA4i6CsQykdCkld+8MENED0pgCM2qxmjffQwQoetNBTcB3fnX/KVZ5Gu98ReQ24pj5QHO3/Cd2IN6hlWVZ56QoilH3DmyV+JQCXtHRgqqqtufz+Utsdjweb2VZ9ryq8eb3hfd+E8SSNsSXRHSMkMcjlGVZvQNVVY0UR+jKe3+CrFEfTxQYcc2Qx0xTo8WKyEQz9KES0Ij4v8MerZvN0Mfpx8MsPnyGjh4s40NRRC40Qx5tL+/RHIFAxURXAwAAAABJRU5ErkJggg=="
                                    preserveAspectRatio="none" width="100%" height="100%" />
                            </g>
                        </svg>
                    </el-icon>
                    <span class="underline text-blue-500">{{ operatorData.operator.telephone }}</span>
                </div>
            </div>

            <!-- 生命体征 -->
            <router-link :to="{
                        name: 'OperatorDetail',
                        params: {
                            site_code: operatorData.operator_status.site_code,
                            operator_code: operatorData.operator.operator_code
                        }}">
                <div class="flex flex-col justify-between items-center mt-2 h-28"
                    :class="getHSIBackgroundColor()">
                    <!-- 非作業中 -->
                    <div v-if="!operatorData.operator_status.is_work" class="text-4xl font-semibold mt-4">作業完了</div>
                    
                    <!-- 通信不能 -->
                    <div v-else-if="!operatorData.is_comm" class="text-4xl font-semibold mt-4">通信不能</div>

                    <!-- 計測不能 -->
                    <el-tooltip v-else-if="operatorData.app_status.status !== '0'" effect="dark"
                        :content="operatorData.app_status.info" placement="top">
                        <span class="text-4xl font-semibold mt-4">
                            計測不能
                        </span>
                    </el-tooltip>

                    <!-- 体温 -->
                    <div v-else class="mt-4">
                        <span class="text-5xl">{{ getTemperatureSplitPoint(operatorData?.vital_data?.body_temperature)[0] }}</span>
                        <span class="text-4xl">{{ getTemperatureSplitPoint(operatorData?.vital_data?.body_temperature)[1] }}</span>
                    </div>

                    <!-- 数据取得时间 -->
                    <div class="flex flex-row items-center">
                        <el-icon :size="30">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                                width="100%" height="100%" style="display: block; margin: auto;">
                                <g>
                                    <image x="0" y="0"
                                        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA/BJREFUaEPtWU2I3VQU/s6LbkYoLpSKrRSti4oiKIo4uLBQlJdzM7yKFUQFXSgiUmhtiz+IdaHSseqiSCkI/lBd+NAOMznJVBd2pbh41C50EFoQqzLiwopQhWdy7B0ymEmTlzBj0hFzl/eem+985++ee0NoeHie14ui6AYiugnAbQBIVQedTudEHMdzRBSKyK9V1aKqgiuV8zzv1jiOJwHcWfKtOVV9PgiCj6pgNkLAGDOpqrurKJSSOSgiT5TtqZ2A67ovE9EzZYoUrB8Qke2j9tZKwPO8TTauCxT4BcDpZO0qAJfnyRHRZt/3jxWRqJUAM/cB3JsDvktEXkvPM/NTAPbnyJ6M43g8DENL+LxRGwFjzFZV/TiLKCIjMZlZc/TcLyK5OVQbAdd19xLRCxll7hMR65XCwczbAHyYFiCiT3zfv7tRDzCztf7WFOgpEbmWma8BcCpPGVV9NAiCt5j5JICNKZmfReSKpglklTgiIve4rruPiPYUuOCYiGzOIQ8i2uD7/vfZfbWFEDP/BmBNCvANEdlpjDmiqr0SAq8D2JGRuUVEBk0S+BTAlhTgFyIyXpAbi2ILJJn5cwC3p5XtdDqXzMzMnG2MgDHmFVV9Og14rufxgiDw8yoNER0fDodbHMcZJ6KZTBIf933/5kZzwBjzgKoezoD+JCLr7FziCXtG/KmqvuM4k9bCzPwjgCsz+/aJyBJjLK7XlgMTExNroyj6EsCGrDWjKNoWhuGSStTtdjc6jtNXVdulLhlRFF09Ozv7XaMesGDMvAvAqznANpaPAvghWVsPwNb5sRzZd0TkkYKkR20eWAR0XfcEEd1YpECV+VH9UO0ErILGmKOqelcVZYtk4jh2wzAMG6tCWaCkNzoIYG0FIrb7PO/iQ0QP+r7//pKcqvCxf03EGLNOVXfY66Sq2rJ4qf24qg6J6GsAAYDDIjLnuu40EXk54NtF5EDtVagK6+S+cNH8/Py3g8FgmN3DzB8AuD87r6p7gyB40c43kgNVyBTJMPMhAI9l1s+OjY1d1u/3/2iUADN/BuBiIpIoir6yp6/jOH+p6iYA16mqPYXfzd7AjDHvqepDaRKO46yZnp7+/UIQGPkqUVQymfltAA8nOfNmEARPNh5CiQeWRSApxwt70x76z3jggp3EaeCVeiCPxLI90Ov1Fmp42ZiamjqzKLOqCDDzSwCeLSFwSEQebwmMsNKyQ6j1QIFVy54Ss9taD7RJnLHAskKo2+12O53Oc2U1XUTuSJXE1VNGEwL2MjFqfHPuYfb6lkDJP7KVhFDrgZz4a6aVaHOgOPVbD5SV9oVWog2hNoT+scD/+hyQkoSZW42txN/j7XhPSt7PDgAAAABJRU5ErkJggg=="
                                        preserveAspectRatio="none" width="100%" height="100%" />
                                </g>
                            </svg>
                        </el-icon>

                        <div class="flex flex-col items-center ml-4">
                            <span class="text-sm"> {{ formattedDate(operatorData?.vital_data?.check_timestamp) }}</span>
                            <span class="text-sm"> {{ formattedTime(operatorData?.vital_data?.check_timestamp) }}</span>
                        </div>
                    </div>
                </div>
            </router-link>

            <!-- 电量 -->
            <div class="flex flex-row mt-2 justify-between">
                <!-- 体温计电量 -->
                <div class="flex flex-row items-center">
                    <el-icon :size="20">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                            width="100%" height="100%" style="display: block; margin: auto;">
                            <g>
                                <image x="0" y="0"
                                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAgBJREFUWEe9l9FxwjAMhq2DPUonaXjjcHZoMgkwCbBDzPHWdJKySM6gnMWpqa3YDmle4Ejw91u/JCugZro2m81quVxW1toPpVShlLo9Ptuu6w7X6xW/9xfMwS/LsniAv9zaLQB8W2vfnBAFAOemafazCNhutxUAHN1ua75bFpUdABxQxEsjwOHGmHUoumVZ7q21nwBQv0xALBxFYSQWiwVadHuJgBQ4RUVrjQJWkwXkwFGEs2E3SYAP7sJ7xMynTPflgtYaEzU/AgL8xwFvvNy4CCcSnztlRSACTjyvCOd/YYyBZAEJcBJxMsbUg+QrHhatm6ZpkwRkwDECNYJQAO3cWltfLpdTUiecAx4tgCVNSx2O/eZL8tGdJx1GPGmGXnro0fCoCNDJxn3DPzJLuIYkeJQA1zAqLJnhbqmbsboXE87n1WgVaK2xYaD3z1LiC/GTTcr20MkYI8AOwy8NMb5Sk54XBVD4u65754NFaMFUuJgDvF+Hws+F5MBFAbQgtcyR6WaH91OsEvuABPdMu7gWTru/5j/Jd37vTw6E4M4S3GnFyu6McMr+WGhQQAjOx2yaZnNgYh8gOA4JPOkYPDvMo2XI4Pjsc4jgcGnMnhINGLRTWqt/jXJ+P0/AKaBgJ3StdhV4YFZ43wcEAbPDewEBC/4F3gvgL4w8Aefw27fmHWGlvbTC0Dy3AAAAAElFTkSuQmCC"
                                    preserveAspectRatio="none" width="100%" height="100%" />
                            </g>
                        </svg>
                    </el-icon>
                    <span class="text-xs ml-1">{{ operatorData.operator_status.calera_battery }}%</span>
                </div>

                <!-- 心拍计电量 -->
                <div class="flex flex-row items-center">
                    <el-icon :size="20">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                            width="100%" height="100%" style="display: block; margin: auto;">
                            <g>
                                <image x="0" y="0"
                                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzRJREFUWEfFVzGO2zAQJCV1/oSvSJkHpIrdHST9IfZDgtx1eUK6+LrUhmi4i9KkDpA2QJQXpHEXUYyH4BormhTlIMC5MWBpl7Ozw9m1FM/8kc98vogCuL+/XxZFsRRCrIZh6A6Hw24uWIodhmGZZVnXNE0bi70CUNf1yhjzORLQSSmfmqZ5CD2v6/rBGPPultgLAId6E0jQCSHABP90Wuv18XjEM4HYPM8/gi32kn3mx0opH3kBFwBVVaFqStC6Fy11OADfeZ6juo1LbNk4x7QeY1exaKUrjPJ3Sqk75LEAOHU+Qp9OV+1PAsErlFKup/odOkd6CXdKqW1KbC4GjF1akzqccjIQYHAry7LcSCnRP6GUsoyUZfkpy7IPqAaixG/GGGrXN6XUby7WuYczvVjwYFtWVYXD0VdbfV3Xr4wxX6WU70+n09vFYvFHCEG3Yp3n+Yv9fv+DWodviIpEHLshnFWmtxYA0E+IZEt3vSzLl4fD4fucVtBNIGq11nf0Wyx+1IaqqoxVY0JAU2C4jnghsRje9iADqcr957yicztxxdZTORiADgDs/U9dv6mEjkXrC7jvKTaZ7lrJ0ZM53MIAVUMFOE2NWCAjI22Q7iB8ACDvH9lrCATY0lpvuchcMlxh62whMbp3WvIYrrvZ45gSc5GR+Hj7yKRoaHGLxw1xlm6dFL5DVgyzIcN57RzOupwfBO8nkREoMjBijXsLPAYAjTFvSKBgHaMa1/6KAT7LpZQQFAYOnBCDCDvBhoMKidcb6RYwZ3AYhpbaOBrHmHbGmC/0gjffrVNSP88+/gugYsbjawNFMPFhgj6NGPBm+kWQFEQ0M3qR8zJWQ96AdmGeIDcqBjN933dcxKMW+KMWSwetZeTxnN45rseF2vf9zrfpKw1wm0SFfPNhIiMVW1VPeP5ovQsZVPAa+iD8PRDPsyxbTk0+f7eMuWPUB1wCjGpaOnZa68fUpAvsh3bxiG1Kk0bkkl3tgaHKI0tt0l1nOWFg3baDB6JC/4ui8LfpyfWda2YWAFqlQgel1u7UYJsNgBLFqJ76wzIF4mYAHEiWZavUbfjvDKQS3vr8nxm49aDY+38Bjj2QC3gkljgAAAAASUVORK5CYII="
                                    preserveAspectRatio="none" width="100%" height="100%" />
                            </g>
                        </svg>
                    </el-icon>
                    <span class="text-xs ml-1">{{ operatorData.operator_status.hrm_battery }}%</span>
                </div>

                <!-- 手机电量 -->
                <div class="flex flex-row items-center">
                    <el-icon :size="20">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                            width="100%" height="100%" style="display: block; margin: auto;">
                            <g>
                                <image x="0" y="0"
                                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAdRJREFUaEPtWjFOw0AQ3PVLQIIGWugDXc5OSw0NFDyC8AgKaKCmje/SAT200BCJvMQLZ9nIQoLM2joE0qZMZud25m5iybdMPT7OuYKZJ0S0T0QbPSi6JQsiuhORWQih1HKxtsA5N2XmM20dgheR8xDCFMG2GJUA59wOMz9qFtBiRWQ3hPCE1qkE5Hl+TUSHKHlP3I33/git1Qp4I6I1lLwnbum9X0drtQIEJR6C897DfcHA2FCe558CmHlvSJNfa0Xkvv3uVwRoFkGEds3RcPfeAc0iJuAHB2wHkOOBYCwDKV1KyW0ZQNxFMJaBlC6l5LYMIO4iGMtASpdSclsGEHcRjGUgpUspuS0DiLsIxjKQ0qWU3JYBxF0EYxlI6VJKbssA4i6CsQykdCkld+8MENED0pgCM2qxmjffQwQoetNBTcB3fnX/KVZ5Gu98ReQ24pj5QHO3/Cd2IN6hlWVZ56QoilH3DmyV+JQCXtHRgqqqtufz+Utsdjweb2VZ9ryq8eb3hfd+E8SSNsSXRHSMkMcjlGVZvQNVVY0UR+jKe3+CrFEfTxQYcc2Qx0xTo8WKyEQz9KES0Ij4v8MerZvN0Mfpx8MsPnyGjh4s40NRRC40Qx5tL+/RHIFAxURXAwAAAABJRU5ErkJggg=="
                                    preserveAspectRatio="none" width="100%" height="100%" />
                            </g>
                        </svg>
                    </el-icon>
                    <span class="text-xs">{{ operatorData.operator_status.phone_battery }}%</span>
                </div>
            </div>

            <!-- 作業終了予定时刻 -->
            <div class="flex mt-4 justify-center items-center">
                <span v-if="operatorData.operator_status.is_work" class="text-sm">
                    作業終了予定&nbsp;&nbsp;{{ formatTimeRange(operatorData.operator_status.planned_end_time, operatorData.server_time) }}
                </span>
                <span v-else class="text-sm">
                    終了時刻&nbsp;&nbsp;{{ formattedDateTime(operatorData?.operator_status?.work_end_time) }}
                </span>
            </div>

        </el-card>
    </div>

    <!-- 新規登録・編集ダイアログ -->
    <el-dialog v-model="dialogFormVisible" title="氏名変更" width="600px" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="auto" @submit.prevent>

            <el-form-item label="作業員名" prop="operator_name">
                <el-input v-model="form.operator_name" placeholder="作業員名を入力" />
            </el-form-item>

        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleUpdateNameSubmit(formRef)">確認</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<style scoped>
.marquee {
    display: inline-block;
    animation: marquee-scroll 10s linear infinite;
}

@keyframes marquee-scroll {
    0% {
        transform: translateX(50%);
    }
    100% {
        transform: translateX(-100%);
    }
}
</style>

<script lang="ts">
import { defineComponent, onUnmounted, ref, nextTick, computed, onMounted } from 'vue';
import axios, { AxiosResponse } from 'axios';
import { ErrorCode, ResponseData, ResponseStatus } from './response';
import { Close} from '@element-plus/icons-vue'
import {  ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { getErrorMessage } from './errorMessage';
import moment from 'moment';
import { DashboardOperatorInfo } from '../models/dashboardinfo';

export default defineComponent({
    name: 'OperatorStatus',
    // 添加 emits 定义
    emits: ['refreshOperatorStatus'],
    components: {
        Close
    },
    props: {
        data: {
            type: Object,
            default: () => ({
                app_status: null,
                operator_status: null,
                is_comm: false,
                operator: {},
                server_time: '',
                vital_data: null,
            })
        },
    },

    setup(props, { emit }) {
        // 确保转换 `operator` 数据类型
        const operatorData = computed<DashboardOperatorInfo>(() => ({
            app_status: props.data?.app_status ?? null,
            operator_status: props.data?.operator_status ?? null,
            is_comm: props.data?.is_comm ?? false,
            operator: props.data?.operator, // 确保 `operator` 字段存在
            server_time: props.data?.server_time ?? '',
            vital_data: props.data?.vital_data ?? null,
        }));

        const dialogFormVisible = ref<boolean>(false);

        const form = ref<any>({
            operator_name: '',
        });

        let intervalId: number | null = null;

        const formRef = ref<FormInstance>()

        const rules = ref<FormRules>({
            operator_name: [
                { required: true, message: '作業員名を入力してください', trigger: 'blur' },
                { min: 2, max: 25, message: '作業員名は2〜25文字の間で入力してください', trigger: 'blur' }
            ],

        })

        const formattedDate = (value: string | null | undefined) => {
            if(value){
                return moment(value).format('YYYY/MM/DD');
            }

            return '----/--/--';
        };


        const formattedTime = (value: string | null | undefined) => {
            if(value){
                return moment(value).format('HH:mm:ss');
            }

            return '--:--:--';
        };

        const formattedDateTime = (value: string | null | undefined) => {
            if(value){
                return moment(value).format('YYYY/MM/DD HH:mm');
            }

            return '----/--/-- --:--';
        };

        const getTemperatureSplitPoint = (value: number | null | undefined) => {
            if(value){
                const v = value.toFixed(2); // 保证保留两位小数
                const [integer, decimal] = v.split('.'); // 拆分整数和小数部分
                return [integer, `.${decimal}`]; // 确保小数部分带 `.`
            }
            
            return ['--', ''];
        };

        // 2024-01-01T18:00:00Z
        const formatTimeRange = (endtime: string, serverTime: string) => {
            try {
                const endTimeUtc = endtime; // 获取后者时间（UTC）

                const now = new Date(serverTime); // 当前本地时间
                now.setMinutes(now.getMinutes() + 2);

                const endTimeLocal = new Date(endTimeUtc); // 转换为本地时间

                // 提取本地时间的 "时:分"
                const endHours = endTimeLocal.getHours();
                const endMinutes = endTimeLocal.getMinutes();

                // 当前本地 "时:分"
                const nowHours = now.getHours();
                const nowMinutes = now.getMinutes();

                // 判断是否为次日
                const isNextDay = endHours < nowHours || (endHours === nowHours && endMinutes < nowMinutes);

                const endHoursStr = String(endHours).padStart(2, '0');
                const endMinutesStr = String(endMinutes).padStart(2, '0')
                if(!isNextDay){
                    return `${endHoursStr}:${endMinutesStr}`;
                }else{
                    return `翌日${endHoursStr}:${endMinutesStr}`;
                }
            } catch (error) {
                return `--:--`;
            }
        };

        const containerRef = ref<HTMLElement | null>(null);
        const textRef = ref<HTMLElement | null>(null);
        const isOverflowing = ref(false);

        const checkOverflow = () => {
            if (containerRef.value && textRef.value) {
                const containerWidth = containerRef.value.offsetWidth; // 容器宽度
                const textWidth = textRef.value.scrollWidth; // 文本的真实宽度
                isOverflowing.value = textWidth > containerWidth; // 判断是否超出
            }
        };

        onMounted(() => {
            intervalId = setInterval(() => {
                updateBreakDuration();
                checkOverflow();
            }, 1000);
        });

        // 添加 onUnmounted 钩子
        onUnmounted(() => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        });

        // 关闭
        const handleCloseButton = () => {
            ElMessageBox.confirm('作業強制完了しますか？', '作業強制完了', {
                confirmButtonText: '作業強制完了',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                forceEndWork();
            }).catch(() => {
            });
        };

        // 更新作業員名
        const handleUpdateName = () => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    operator_name: operatorData.value.operator.operator_name,
                };
            });
        };

        const handleUpdateNameSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid) => {
                if (valid) {
                    updateName();
                    dialogFormVisible.value = false;
                }
            })
        }

        // EndWork
        const forceEndWork = async () => {
            try {
                const response = await axios.post('/api/operator2/workend', {
                    site_code: operatorData.value.operator_status.site_code,
                    operator_code: operatorData.value.operator.operator_code,
                });
                if (response.data.code === ErrorCode.OK) {
                    // 通知父组件刷新
                    emit('refreshOperatorStatus');
                }
            } catch (error) {
                // console.error('forceEndWork error:', error);
                ElMessage.error(getErrorMessage(error as Error));
            }
        };

        // 更新作業員名
        const updateName = async () => {
            try {
                const res: AxiosResponse<ResponseData<any>> = await axios.put(`/api/operators2/${operatorData.value.operator.id}`, form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    ElMessage.success(res.data.message);
                } else {
                    ElMessage.error(res.data.message);
                }
                // 通知父组件刷新
                emit('refreshOperatorStatus');
            } catch (error) {
                ElMessage.error(getErrorMessage(error as Error));
            }
        };

        // 计算休憩时间
        const breakDuration = ref('00:00:00');
        const updateBreakDuration = () => {
            if (!operatorData.value.operator_status.break_start_time) {
                breakDuration.value = '00:00:00';
                return;
            }

            const breakStartTime = new Date(operatorData.value.operator_status.break_start_time);
            const currentTime = new Date();
            const duration = currentTime.getTime() - breakStartTime.getTime();

            const hours = Math.floor(duration / (1000 * 60 * 60));
            const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((duration % (1000 * 60)) / 1000);

            breakDuration.value = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };

        /**
         * 获取HSI状态
         * @param heatStrainIndex 
         */
        const getHSIStatus = (heatStrainIndex: number | undefined) => {
            if (heatStrainIndex === undefined || heatStrainIndex === null || heatStrainIndex > 10 || heatStrainIndex < 0) {
                return 'unknown';
            } else if (heatStrainIndex < 1) {
                return 'safe';
            } else if (heatStrainIndex < 3) {
                return 'medium';
            } else if (heatStrainIndex < 7) {
                return 'high';
            }
            return 'danger';
        };

        /**
         * 获取HSI背景颜色
         * @param heatStrainIndex 
         */
        const getHSIBackgroundColor = () => {
            const isWork = operatorData.value.operator_status.is_work;
            if(!isWork){
                return 'bg-gray-300';
            }

            const isComm = operatorData.value.is_comm;
            if(!isComm){
                return 'bg-gray-300';
            }

            const appStatus = operatorData.value.app_status.status === '0';
            if(!appStatus){
                return 'bg-gray-300';
            }

            const hsiStatus = getHSIStatus(operatorData.value.vital_data?.heat_strain_index);
            switch (hsiStatus) {
                case 'unknown':
                    return 'bg-gray-300';
                case 'safe':
                    return 'bg-teal-500';
                case 'medium':
                    return 'bg-yellow-400';
                case 'high':
                    return 'bg-amber-500';
                case 'danger':
                    return 'bg-red-400';
            }
        };



        return {
            form,
            rules,
            formRef,
            dialogFormVisible,
            breakDuration,
            containerRef,
            textRef,
            isOverflowing,
            formattedDate,
            formattedTime,
            formattedDateTime,
            getTemperatureSplitPoint,
            formatTimeRange,
            handleUpdateName,
            handleUpdateNameSubmit,
            handleCloseButton,
            getHSIBackgroundColor,
            checkOverflow,
            operatorData,
        };
    },
});
</script>